var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7207 26.2443C24.7688 26.5793 24.9326 26.8857 25.1819 27.1073L30.8007 32.1026C31.1486 32.4119 31.6256 32.5381 32.0387 32.3346C32.3323 32.1899 32.6628 31.9797 32.9048 31.6908C33.1468 31.4019 33.3003 31.0343 33.3962 30.7139C33.5312 30.2631 33.3402 29.7955 32.9923 29.4862L27.388 24.5039C27.1293 24.2739 26.7992 24.1473 26.4581 24.1473L25.9242 24.1473C25.6523 24.1473 25.4084 23.9734 25.3123 23.7112V23.7112C25.1379 23.2354 24.5337 23.122 24.2109 23.5046L23.7214 24.0849C23.401 24.4646 23.6221 25.0606 24.1077 25.1264V25.1264C24.3804 25.1634 24.5967 25.3825 24.637 25.6627L24.7207 26.2443Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.359682
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2753 7.19516C10.2249 7.19516 6.13077 11.413 6.13077 16.616C6.13077 21.8191 10.2249 26.0369 15.2753 26.0369C20.3257 26.0369 24.4198 21.8191 24.4198 16.616C24.4198 11.413 20.3257 7.19516 15.2753 7.19516ZM4 16.616C4 10.2007 9.04812 5 15.2753 5C21.5025 5 26.5506 10.2007 26.5506 16.616C26.5506 23.0314 21.5025 28.2321 15.2753 28.2321C9.04812 28.2321 4 23.0314 4 16.616Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.359682
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75195 13.4531V21.4459C9.75195 21.5452 9.83247 21.6257 9.93179 21.6257H21.9112",
    stroke: "#191919",
    strokeWidth: 0.719365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8086 19.421V16.543",
    stroke: "#191919",
    strokeWidth: 0.719365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.252 19.4177L16.252 14.9375",
    stroke: "#191919",
    strokeWidth: 0.719365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6914 19.421V16.543",
    stroke: "#191919",
    strokeWidth: 0.719365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 14.1288L15.7722 12.0441C15.8255 12.0142 15.8904 12.0134 15.9444 12.042L18.9457 13.6297C19.0086 13.663 19.0852 13.6561 19.1411 13.612L20.5155 12.5293",
    stroke: "#E3D6C7",
    strokeWidth: 0.719365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomInsights);
export default __webpack_public_path__ + "static/media/customInsights.ac0ed158705de5fbc0c466973602c80e.svg";
export { ForwardRef as ReactComponent };